<template>
  <tr class="rf-skeleton-row h-32">
    <td class="pr-0! whitespace-nowrap" style="min-width: calc(24px + 1rem)"></td>
    <td class="5xl:pl-7! w-full pr-0! pl-2!">
      <div class="5xl:gap-7 flex items-center justify-start gap-2">
        <RfBaseSkeleton class="5xl:hidden! inline-flex!" width="44" />
        <RfBaseSkeleton class="5xl:inline-flex! hidden!" width="108" />
        <div class="flex items-center gap-5">
          <div class="block h-24 w-32 shrink-0">
            <RfBaseSkeleton width="128" height="96" radius="4" />
          </div>
          <div class="flex flex-col gap-3">
            <RfBaseSkeleton class="3xl:hidden! flex!" width="100" dynamic />
            <RfBaseSkeleton class="3xl:flex! hidden!" width="238" dynamic />
            <RfBaseSkeleton class="3xl:hidden! flex!" width="100" dynamic />
            <RfBaseSkeleton class="3xl:flex! hidden!" width="238" dynamic />
            <template v-for="i in ~~(Math.random() * 2 + 1)" :key="i">
              <RfBaseSkeleton class="3xl:hidden! flex!" width="65" dynamic />
              <RfBaseSkeleton class="3xl:flex! hidden!" width="132" dynamic />
            </template>
          </div>
        </div>
      </div>
    </td>

    <td>
      <div class="flex w-28 flex-col gap-3">
        <template v-for="i in ~~(Math.random() * 3 + 1)" :key="i">
          <RfBaseSkeleton width="81" dynamic />
        </template>
      </div>
    </td>

    <td v-if="engagementCategoriesEnabled" class="w-0">
      <div class="flex w-28 flex-col items-start gap-2">
        <RfBaseSkeleton width="80" height="20" />
      </div>
    </td>

    <template v-if="!performanceCols">
      <td>
        <div class="5xl:min-w-40 flex w-24 flex-col gap-3">
          <template v-for="i in ~~(Math.random() * 3 + 1)" :key="i">
            <RfBaseSkeleton width="81" dynamic />
          </template>
        </div>
      </td>
      <td class="px-4! text-start whitespace-nowrap"><RfBaseSkeleton width="59" /></td>
      <td class="px-4! text-start whitespace-nowrap"><RfBaseSkeleton width="59" /></td>
    </template>

    <td class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>

    <template v-if="performanceCols">
      <td class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>
      <td class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>
      <td class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>
    </template>

    <td class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>
    <td v-if="!performanceCols" class="bg-goal text-right"><RfBaseSkeleton width="50" /></td>
    <td class="px-2!"></td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";

defineProps({
  performanceCols: { type: Boolean, default: false },
  engagementCategoriesEnabled: { type: Boolean, default: false },
});
</script>
